import type { FlexProps } from '@lemonade-hq/uniclient-theme';
import { Flex } from '@lemonade-hq/uniclient-theme';
import { clsx } from 'clsx';
import type { PropsWithChildren } from 'react';
import React, { forwardRef } from 'react';
import * as styles from './WizardScrollSnapContainer.css';

interface WizardScrollSnapContainerProps extends FlexProps {
  readonly scrollSnapAlign: 'end' | 'start';
}

export const WizardScrollSnapContainer = forwardRef<HTMLDivElement, PropsWithChildren<WizardScrollSnapContainerProps>>(
  ({ scrollSnapAlign, className, children, ...props }, ref) => (
    <Flex
      {...props}
      className={clsx(styles.container, scrollSnapAlign === 'start' && styles.snapStart, className)}
      ref={ref}
    >
      {children}
    </Flex>
  ),
);
